import { render, staticRenderFns } from "./cctCanabis.vue?vue&type=template&id=49cd3532"
import script from "./cctCanabis.vue?vue&type=script&lang=js"
export * from "./cctCanabis.vue?vue&type=script&lang=js"
import style0 from "./cctCanabis.vue?vue&type=style&index=0&id=49cd3532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports